import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type FeatureFlagsService from 'garaje/services/feature-flags';

export default class CommunicationsAlertsRoute extends Route {
  @service declare router: RouterService;
  @service declare featureFlags: FeatureFlagsService;

  beforeModel(): void {
    if (!this.featureFlags.isEnabled('threat-weather-alerts-web')) {
      void this.router.transitionTo('communications.message-log.new');
    }
  }
}
